// extracted by mini-css-extract-plugin
export default {"main":"BlockClickPropagation_main__uoEqo"};